export function initVideoModal() {
    const modal = document.getElementById('videoModal');
    const content = document.getElementById('videoContent');

    if (!modal || !content) return;

    let activeVideo = null;

    function closeModal() {
        if (activeVideo) {
            activeVideo.pause();
            activeVideo.currentTime = 0;
            activeVideo.removeAttribute('src');
            activeVideo.load();
            activeVideo = null;
        }
        content.innerHTML = '';
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
    }

    document.querySelectorAll('.btn-play').forEach(btn => {
        btn.addEventListener('click', () => {
            const src = btn.dataset.video;
            const poster = btn.dataset.poster || '';
            const videoName = btn.dataset.videoName || '';
            const videoLang = btn.dataset.videoLang || '';

            if (src.endsWith('.mp4')) {
                const video = document.createElement('video');
                video.controls = true;
                video.playsInline = true;
                video.preload = 'none';
                video.setAttribute('aria-label', btn.getAttribute('aria-label') || '');
                if (poster) video.poster = poster;
                video.src = src;
                content.appendChild(video);
                activeVideo = video;

                video.play().catch(() => {});

                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'video_play',
                        video_name: videoName,
                        video_lang: videoLang
                    });
                }

                video.addEventListener('ended', () => {
                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'video_complete',
                            video_name: videoName,
                            video_lang: videoLang
                        });
                    }
                });
            } else {
                const iframe = document.createElement('iframe');
                iframe.src = src;
                iframe.title = btn.getAttribute('aria-label') || '';
                iframe.setAttribute('frameborder', '0');
                iframe.allow = 'autoplay; encrypted-media';
                iframe.allowFullscreen = true;
                content.appendChild(iframe);
            }

            modal.classList.add('is-open');
            modal.setAttribute('aria-hidden', 'false');
        });
    });

    modal.querySelector('.video-backdrop').addEventListener('click', closeModal);
    modal.querySelector('.video-close').addEventListener('click', closeModal);

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
            closeModal();
        }
    });
}
